
<div class="tuk-loader">
  <div class="loade" @click="hide">
    <!-- <img class="loade__animated" src="https://image.flaticon.com/icons/svg/561/561071.svg" />
    <img src="https://image.flaticon.com/icons/svg/560/560969.svg" /> -->
    <div v-if="isPicante()">
      <img class="loade__animated" src="/img/icons/picante_loading.svg" />
      <img class="tuk-grey" src="/img/icons/picante_loading_grey.svg" />
    </div>
    <div v-else>
      <img class="loade__animated" src="/img/icons/tuk-loading-color.png" />
      <img class="tuk-grey" src="/img/icons/tuk-loading-grey.png" />
    </div>
  </div>
</div>
